<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__slcustomer}">
      <div class="repayment-top">
        <el-descriptions class="margin-top" :column="1">
          <el-descriptions-item label="渠道订单号：">{{
            row.applyNo
          }}</el-descriptions-item>
          <el-descriptions-item label="进件ID：">{{
            row.id
          }}</el-descriptions-item>
          <el-descriptions-item label="进件时间：">{{
            row.createDate
          }}</el-descriptions-item>
          <el-descriptions-item label="进件状态：">{{
            geteducation(row.status, "status") || row.status
          }}</el-descriptions-item>
        </el-descriptions>
        <el-descriptions class="margin-top" :column="1">
          <el-descriptions-item label="客户姓名：">{{
            row.borrowerInformation.姓名
          }}</el-descriptions-item>
          <el-descriptions-item label="手机号：">{{
            row.borrowerInformation.手机号
          }}</el-descriptions-item>
          <el-descriptions-item label="身份证号：">{{
            row.borrowerInformation.身份证号 || row.borrowerInformation.身份证
          }}</el-descriptions-item>
          <el-descriptions-item label="企业名称：">{{
            row.borrowerInformation.企业名称
          }}</el-descriptions-item>
          <el-descriptions-item label="营业执照号：">{{
            row.borrowerInformation.营业执照号
          }}</el-descriptions-item>
        </el-descriptions>
      </div>

      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="id"
          label="资金计划ID"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="period"
          label="期次"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="currentPeriodDate"
          label="本期还款日"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="currentAmount"
          label="当期还款金额"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="realRepaymentDate"
          label="实际还款日"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="repaymentAmount"
          label="还款金额"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="repaymentType"
          label="还款类型"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="planType"
          label="资金计划类型"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="needPaymentDate"
          label="应还款日"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="needPaymentAmount"
          label="应还款金额"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="overdueDays"
          label="已逾期天数"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="overdueAmount"
          label="逾期金额"
          header-align="center"
          align="center"
        ></el-table-column>
      </el-table>
    </div>
    <!-- <el-pagination :current-page="page" :page-sizes="[10, 20, 50, 100]" :page-size="limit" :total="total"
        layout="total, sizes, prev, pager, next, jumper" @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination> -->
  </el-card>
</template>
<style scoped>
.xiang {
  color: rgb(30, 152, 215);
}
.repayment-top {
  display: flex;
  width: 40%;
  justify-content: space-between;
  margin-bottom: 2rem;
}
</style>
<script>
import mixinViewModule from "@/mixins/view-module";
import { getList, pageList } from "@/api/list";
// import AddOrUpdate from './entry-add-or-update'
export default {
  mixins: [mixinViewModule],
  props: {
    row: {},
    closeData: {},
  },
  data() {
    return {
      applyNo: null,
      mixinViewModuleOptions: {
        getDataListURL:
          "/sys/slproductRepaymentplan/page?applyNo=" + this.row.applyNo,
        getDataListIsPage: true,
        // exportURL: "/sys/slproducttender/export",
        exportURL: "/sys/inputmanagement/export",
        deleteURL: "/sys/slproducttender",
        deleteIsBatch: true,
      },
      text: "修改",
      userTypes: [],
      statusList: [],
      statusList2: [],
      mechanismNames: [],
      productNameList: [],
      dataForm: {
        status: "",
        id: "",
        userType: "",
        productCode: "",
        startDate: "",
        endDate: "",
      },
      dateValue: "",
    };
  },
  watch: {
    closeData(newVal) {
      // 处理接收到的信息
      if (newVal.message) {
        this.row.borrowerInformation = "";
        console.log(this.row.borrowerInformation);
      }
    },
  },
  created() {
    console.log(this.row.applyNo);
    this.zhuanhuan();
    // console.log(this.row); //获取永赢进件页面跳转进来时的数据
    getList("/sys/inputmanagement/mechanism").then(({ data: res }) => {
      console.log(res.data);
      this.mechanismNames = res.data.map((item) => {
        return { value: item.name, label: item.name };
      });
      // this.mechanismNames
    });
    pageList("/sys/inputmanagement/slproduct").then(({ data: res }) => {
// /      console.log(res.data.list);
      this.productNameList = res.data.list.map((item) => {
        return { value: item.id, label: item.productName };
      });
      // this.mechanismNames
    });
    this.getentryStatusOptions();
  },

  methods: {
    async getentryStatusOptions() {
      this.$http
        .get(`/sys/dict/data/list?dataType=entryStatus`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.statusList = [];
          this.statusList2 = [];
          if (res.data != null) {
            res.data.forEach((element) => {
              this.statusList.push({
                label: element.dictLabel,
                value: element.dictValue,
              });
              this.statusList2.push({
                label: element.dictLabel,
                value: element.dictValue,
              });
            });
            // {label: '未在本机构完成申请', value: '6'}
            // this.statusList2.push(
            //   { label: "审核未通过", value: "-1" },
            //   { label: "失效", value: "7" }
            // );
          }
        })
        .catch(() => {});
    },
    geteducation(v, name) {
      return this.statusList2.filter((item) => item.value == v)[0]?.label;
    },
    zhuanhuan() {
      // if (this.row.status) {
      //   if (this.row.status == 0) {
      //     this.row.status = "申请中";
      //   }
      //   if (this.row.status == 1) {
      //     this.row.status = "完成申请";
      //   }
      //   if (this.row.status == 2) {
      //     this.row.status = "审核通过";
      //   }
      //   if (this.row.status == 3) {
      //     this.row.status = "已核额";
      //   }
      //   if (this.row.status == 4) {
      //     this.row.status = "未放款";
      //   }
      //   if (this.row.status == 5) {
      //     this.row.status = "放款成功";
      //   }
      //   if (this.row.status == -1) {
      //     this.row.status = "审核未通过";
      //   }
      //   if (this.row.status == 7) {
      //     this.row.status = "失效";
      //   }
      // }
      try {
        this.row.borrowerInformation = JSON.parse(this.row.borrowerInformation);
        console.log( this.row.borrowerInformation)
      } catch (e) {
        console.log(" this.row.borrowerInformation 不是字符串");
      }
    },
    getTimes() {
      if (this.dateValue != null) {
        this.dataForm.startDate = this.dateValue[0] + " 00：00：00";
        this.dataForm.endDate = this.dateValue[1] + " 23：59：59";
      } else {
        delete this.dataForm.startDate 
          delete this.dataForm.endDate
      }
    },
    ///sys/mechanism/list
    getText(v) {
      // console.log(v);
      if (v) {
        return `姓名: ${JSON.parse(v)["姓名"]}<br/>手机号: ${
          JSON.parse(v)["手机号"]
        }<br/>身份证号: ${JSON.parse(v)["身份证号"]}<br/>企业名称: ${
          JSON.parse(v)["企业名称"]
        }<br/>营业执照号: ${JSON.parse(v)["营业执照号"]}`;
      }
    },
    ifTrue(row) {
      if (row.applyNo) {
        return false;
      } else {
        if (row.status != "-1" && row.status != "7") {
          return true;
        }
        return false;
      }
    },
  },
  components: {
    // AddOrUpdate
  },
};
</script>
